import {cDisplay} from '../creator/cDisplay'
import { cGame } from '../creator/cGame';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import {cScene} from '../creator/cScene'


export class gameCanidoDisplay extends cDisplay {

  private sceneNames: string[]
  private holder: cContainer
  private buttonHolder: cContainer
  private prevScene: cInlineDisplay
  private curScene: cInlineDisplay
  private totalScenes: number

  init(){
    var sc:cScene = this.scene as cScene;
    var prefix = sc.sceneData.options.scenePrefix;
    this.totalScenes  = Number(sc.sceneData.options.scsneCount);
    super.init();

    this.sceneNames = [];
    for (var a=0;a < this.totalScenes;a++){
      this.sceneNames.splice( Math.floor( Math.random() * this.sceneNames.length), 0, prefix+a);
    }

    console.log('INIT CAN I DO', this.sceneNames);
    console.log(sc.sceneData);

    (this.scene as cScene).ev.addListener('action',(action,options)=>{
      if (options.command === 'submit'){
        this.checkSubmit( Number(options.options) )
      }
    })
  }

  buildScene(){    
    var sc:cScene = this.scene as cScene;
    super.buildScene();  

    var bg = this.getByName('background')
    this.holder = this.getByName('holder')
    this.buttonHolder = this.getByName('button_holder')

    var maskSp = this.getByName('mask');
    maskSp.visible = false

    // console.log('MASK',this.mask)
    // console.log('SC',this.scene)
    // console.log('BG',bg)

    var m = new Phaser.Display.Masks.BitmapMask(cGame.current.currentScene as any, maskSp);
    //console.log('MM',m)

    bg.mask = m
    this.holder.mask = m

    this.nextScene();
  }


  nextScene(){

    this.buttonHolder.visible = false

    this.prevScene = this.curScene;
    var nm: string = this.sceneNames.pop();

    console.log(this.sceneNames,nm)
    this.curScene = new cInlineDisplay(this.scene as cScene,{
      id: '00',
      name: '',
      type: '',
      asset: nm
    },()=>{
      console.log('next screen ready')
      this.slidein();
    })

    this.curScene.x = 1920
    this.holder.add(this.curScene);
  }


  slidein(){
    var bg = this.getByName('bg')
    var ofs = (this.totalScenes - this.sceneNames.length) * 100
    this.scene.add.tween({
      targets: bg,
      ease:  Phaser.Math.Easing.Quartic.InOut,
      x: -ofs,
      duration: 3000
    })

    this.scene.add.tween({
      targets: this.holder,
      duration: 3000,
      ease:  Phaser.Math.Easing.Quartic.InOut,
      x: -1920,        
      onComplete:()=>{
        this.resetSlide();
      }
    })
  }


  resetSlide(){
    if (this.prevScene){
      this.remove( this.prevScene )
      this.prevScene.destroy()
    }
    this.curScene.x = 0
    this.holder.x = 0
    this.buttonHolder.visible = true
  }


  showInline(name, cb){
    var onExit = (command:string, opt:any)=>{      
      if (opt.command === 'custome' && opt.options === 'cleanup'){
        (this.scene as cScene).ev.removeListener('action', onExit);
        cb();
      }
    }
    var inlineDisp = new cInlineDisplay(this.scene as cScene, {id: '',name: '',type: '', asset: name}, ()=>{ });
    (this.scene as cScene).ev.addListener('action', onExit);
    this.add(inlineDisp)
  }


  checkSubmit(opt){
    var curSceneCorrect = Number(this.curScene.sceneData.options.correct)

    if (curSceneCorrect === opt){
      console.log('COORECT');
      if (this.sceneNames.length > 0){
        this.nextScene();
      }else{     
        this.showInline('00_gameresult',()=>{
          (this.scene as cScene).triggerSceneEvent('completed')
        });
      }
    }else{

    }
    //console.log(curSceneCorrect, opt  )
  }


}
